import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Card, CardContent, Grid, Radio, 
  RadioGroup, FormControlLabel, Slider, TextField, Button, Snackbar } from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import CloseIcon from '@material-ui/icons/FileCopy';
import DateFnsUtils from '@date-io/date-fns';
import format from "date-fns/format";
import ja from 'date-fns/locale/ja'
import { DateTime } from 'luxon';
import ReactGA from "react-ga4";

const useStyles = makeStyles((theme) => ({
    subtitle: {
        '&::before': {
          content: '"■"',
          paddingRight: '4px',
          color: theme.palette.secondary.main,
          fontSize: '2em',
        }
      },
      box: {
        width: '100%',
        marginTop: '40px'
      },
      planGlid: {
        marginTop: '20px',
      },
      planGlidTitle: {
        fontWeight: 700,
        color: theme.palette.primary.main

      },
      textContent: {
        whiteSpace: "pre-line",
      },
      changeText: {
        color: theme.palette.secondary.main
      }
}));

class JaLocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText(date) {
    return format(date, "yyyy / MM / dd", { locale: this.locale });
  }
}
const dateAdditions = { 
  none: { value:0, label: "",},
  add: { value: 5000, label: "+5000円"},
  discount: { value: -5000, label: "-5000円"}};

const backgroundWeight = [
  { value: 0, label: 'なし/単色'},
  { value: 5000, label: 'おまかせ'},
  { value: 10000, label: '背景メイン'}
];
const getBGWLabel = (value) => {
  if (value == 0){
    return backgroundWeight[0]
  } else if (value == 5000){
    return backgroundWeight[1]
  } else {
    return backgroundWeight[2]
  }
}
const getPaymentLabel = (payment) =>{
    if (payment == "prepaid") {
      return "先払い"
    } else if (payment == "middle"){
      return "ラフ確認後"
    } else {
      return "納品前"
    }
}
const template = `以下、テンプレートです。適宜変更してご使用ください。
【概要】ex.歌ってみたMV用イラスト、同人誌表紙絵 など
【詳細】
  ・キャラクターデザインの有無(URLがあると嬉しいです)
  ・背景の詳細
  ・差分の希望
【使用用途 / 範囲】動画のサムネ、グッズ販売
【データ形式】jpeg / png / PSD
【サイズ】 1280 x 720 / 16:9
【制作物の公表 / 実績への記載許可】 OK・NG`

const Simulation = () => {
  const classes = useStyles();
  // 日付関連
  const today = new Date()
  var dt = new Date()
  const [selectedDate, setSelectedDate] = useState(dt.setDate(dt.getDate() + 30));
  const [afterDate, setAfterDate] = React.useState(30);
  const [dateAddition, setDateAddition] = React.useState(dateAdditions.none)
  const handleDateChange = (date: DateTime) => {
    setSelectedDate(date);
    var diffTime = today.getTime() - date.getTime();
    var diffDay = Math.floor(diffTime / (1000 * 60 * 60 * 24)) * -1;
    setAfterDate(diffDay)
    if (diffDay <= 21) {
      setDateAddition(dateAdditions.add)
    } else if (diffDay >= 50) {
      setDateAddition(dateAdditions.discount)
    } else {
      setDateAddition(dateAdditions.none)
    }
    ReactGA.event("input_date", `${date}`);
  };
  // 支払い
  const [payment, setPayment] = React.useState('prepaid');
  const handlePaymentChange = (event) => {
    setPayment(event.target.value);
  };
  const [negotiable, setNegotiable] = React.useState('ok');
  const handleNegotiableChange = (event) => {
    setNegotiable(event.target.value);
  }
  // ご依頼経験
  const [orderTime, setOrderTime] = React.useState('first');
  const [orderTimeDiscount, setOrderTimeDiscount] = React.useState('');
  const handleOrderTimeChange = (event) => {
    const num = event.target.value
    setOrderTime(event.target.value);
    if (num == 'not') {
      setOrderTimeDiscount('10% OFF')
      ReactGA.event("input_order_time", `1回以上`);
    } else {
      setOrderTimeDiscount('')
      ReactGA.event("input_order_time", `初めて`);
    }
  };
  // ラフパターン数
  const [roughPattern, setRoughPattern] = React.useState('1');
  const [roughPatternDiscount, setRoughPatternDiscount] = React.useState('');
  const handleRoughPatternChange = (event) => {
    const num = event.target.value
    setRoughPattern(num)
    if (num == 2){
      setRoughPatternDiscount('+2000円')
    } else if (num == 3){
      setRoughPatternDiscount('+4000円')
    } else {
      setRoughPatternDiscount('')
    }
    ReactGA.event("input_raugh_pattern", `${num}`);
  }
  // 背景
  const [bwValue, setBw] = React.useState(5000);
  const [orderBWDiscount, setBWDiscount] = React.useState('+5000円');
  const handleBackgroundWeightChange = (_, num) => {
    setBw(num);
    if (num != 0) {
      setBWDiscount('+' + num + '円')
    } else {
      setBWDiscount('')
    }
    ReactGA.event("input_background", `${num}`);
  };
  // 概要
  const [detail, setDeteil] = React.useState(template);
  const handleDetailChange = (event) => {
    setDeteil(event.target.value)
  }

  // 見積もり計算
  const [estimate, setEstimate] = React.useState(20000)
  useEffect(() => {
    const basic = 15000
    const order = (orderTime == 'not') ? 0.9 : 1.0
    const rough = (roughPattern - 1) * 2000
    setEstimate((basic + dateAddition.value + bwValue + rough) * order)
  },[dateAddition, bwValue, orderTime, roughPattern]);

  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const copyToClipboard = async () => {
    let array = [
      [`見積もり金額：${estimate.toLocaleString()}円`],
      [`金額について：${negotiable == 'ok' ? 'ご予算内' : '相談したい'}`],
      [`めるろってへのご依頼：${orderTime == 'first' ? '初めて' : '2回目以降 【10% OFF】'}`],
      [`希望納期：${format(selectedDate, "yyyy / MM / dd")} 【${afterDate}日後】`],
      [`ラフ枚数：${roughPattern} 枚`],
      [`背景：${getBGWLabel(bwValue).label} 【${getBGWLabel(bwValue).value}円】`],
      [`支払い：${getPaymentLabel(payment)}`],
      [`ご依頼の概要：${detail}`],
    ];
    await global.navigator.clipboard.writeText(array.join('\n'));
    setOpen(true);
    ReactGA.event("copy_clip_board");
  };
  
  return (
  <Box className={classes.box}>
    <Card variant="outlined">
      <CardContent>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center">
          <Grid item xs={12} md={8}>
          <Typography variant="subtitle1" className={classes.subtitle} gutterBottom>
            事前見積もり（イラスト）
          </Typography>
          </Grid>
          <Grid item xs={8} md={2} className={classes.planGlidTitle}>見積もり金額</Grid>
          <Grid item xs={4} md={2}>{estimate.toLocaleString()}円</Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={3} className={classes.planGlidTitle}>金額について</Grid>
          <Grid item xs={11} md={9}>
            <RadioGroup row aria-label="negotiable" name="negotiable" value={negotiable} onChange={handleNegotiableChange}>
              <FormControlLabel value="ok" control={<Radio />} label="ご予算内" />
              <FormControlLabel value="negotiable" control={<Radio />} label="相談したい" />
            </RadioGroup>
          </Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={3} className={classes.planGlidTitle}>めるろってへのご依頼</Grid>
          <Grid item xs={9} md={7}>
          <RadioGroup row aria-label="orderTime" name="orderTime" value={orderTime} onChange={handleOrderTimeChange}>
            <FormControlLabel value="first" control={<Radio />} label="初めて" />
            <FormControlLabel value="not" control={<Radio />} label="2回目以降" />
          </RadioGroup>
          </Grid>
          <Grid item xs={2} md={2} className={classes.changeText}>{orderTimeDiscount}</Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={3} className={classes.planGlidTitle}>希望納期</Grid>
          <Grid item xs={4} md={4}>
            <MuiPickersUtilsProvider 
            utils={JaLocalizedUtils} 
            locale={ja}>
              <DatePicker
              value={selectedDate}
              format="yyyy / MM / dd"
              inputVariant= "standard"
              onChange={handleDateChange}
              minDate={new Date()} />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={2} md={2}></Grid>
          <Grid item xs={2} md={1}>{afterDate}日後</Grid>
          <Grid item xs={2} md={2} className={classes.changeText}>{dateAddition.label}</Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={3} className={classes.planGlidTitle}>ラフ枚数</Grid>
          <Grid item xs={9} md={7}>
          <RadioGroup row aria-label="roughPattern" name="roughPattern" value={roughPattern} onChange={handleRoughPatternChange}>
            <FormControlLabel value='1' control={<Radio />} label="1" />
            <FormControlLabel value='2' control={<Radio />} label="2" />
            <FormControlLabel value='3' control={<Radio />} label="3" />
          </RadioGroup>
          </Grid>
          <Grid item xs={2} md={2} className={classes.changeText}>{roughPatternDiscount}</Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={3} className={classes.planGlidTitle}>背景</Grid>
          <Grid item xs={6} md={5}>
            <Slider
              aria-label="Background Weight"
              value={bwValue}
              step={5000}
              valueLabelDisplay="auto"
              onChange={handleBackgroundWeightChange}
              max={10000}
              marks={backgroundWeight}
            />
          </Grid>
          <Grid item xs={2} md={2}></Grid>
          <Grid item xs={2} md={2} className={classes.changeText}>{orderBWDiscount}</Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={3} className={classes.planGlidTitle}>支払い</Grid>
          <Grid item xs={11} md={9}>
          <RadioGroup row aria-label="payment" name="payment" value={payment} onChange={handlePaymentChange}>
            <FormControlLabel value="prepaid" control={<Radio />} label="先払い" />
            <FormControlLabel value="middle" control={<Radio />} label="ラフ確認後" />
            <FormControlLabel value="last" control={<Radio />} label="納品前" />
          </RadioGroup>
          </Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={12} md={2} className={classes.planGlidTitle}>ご依頼の概要</Grid>
          <Grid item xs={12} md={10}>
            <TextField
              hiddenLabel
              id="textfield"
              value={detail}
              onChange={handleDetailChange}
              variant="outlined"
              multiline
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={6} md={3} className={classes.planGlidTitle}>
            <Button 
              variant="contained" 
              color="secondary"
              onClick={copyToClipboard}
              endIcon={<CloseIcon />}>見積もりコピー</Button><br />
          </Grid>
        </Grid>
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.planGlid}>
          <Grid item xs={6} md={7} >
            <Typography variant="caption">
            ご依頼時にそのまま貼り付けていただくと嬉しいです！
            </Typography>
          </Grid>
        </Grid>

      </CardContent> 
    </Card>
    <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message="クリップボードにコピーしました"
      />
  </Box>
  );
}
export default Simulation;

